"use strict";
import { LoadingRow } from "components/Loader/styled";
import { RowBetween } from "components/Row";
import { MouseoverTooltip } from "components/Tooltip";
import { useIsMobile } from "hooks/screenSize";
import useHoverProps from "hooks/useHoverProps";
import styled from "lib/styled-components";
import { ThemedText } from "theme/components";
const LabelText = styled(ThemedText.BodySmall)`
  cursor: ${({ hasTooltip }) => hasTooltip ? "help" : "auto"};
  color: ${({ theme }) => theme.neutral2};
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;
const DetailRowValue = styled(ThemedText.BodySmall)`
  text-align: right;
  overflow-wrap: break-word;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;
function ValueWrapper({ children, lineItem, labelHovered, syncing }) {
  const { TooltipBody, tooltipSize, loaderWidth } = lineItem;
  const isMobile = useIsMobile();
  if (syncing) {
    return <LoadingRow data-testid="loading-row" height={15} width={loaderWidth ?? 50} />;
  }
  if (!TooltipBody) {
    return <DetailRowValue>{children}</DetailRowValue>;
  }
  return <MouseoverTooltip
    placement={isMobile ? "auto" : "right"}
    forceShow={labelHovered}
    size={tooltipSize}
    text={<ThemedText.Caption color="neutral2"><TooltipBody /></ThemedText.Caption>}
  ><DetailRowValue>{children}</DetailRowValue></MouseoverTooltip>;
}
export function DetailLineItem({ LineItem, syncing }) {
  const [labelHovered, hoverProps] = useHoverProps();
  return <RowBetween>
    <LabelText {...hoverProps} hasTooltip={!!LineItem.TooltipBody} data-testid="swap-li-label"><LineItem.Label /></LabelText>
    <ValueWrapper lineItem={LineItem} labelHovered={labelHovered} syncing={syncing ?? false}><LineItem.Value /></ValueWrapper>
  </RowBetween>;
}
